import React from "react";
import { SlideshowLightbox } from "lightbox.js-react";

const LightboxWrapper = ({ children }) => {
    return (
        <SlideshowLightbox
            className="lightbox-wrapper"
            showThumbnails={true}
            showControls={true}
            slideAnimationDuration={0.5}
        >
            {children}
        </SlideshowLightbox>
    );
};

export default LightboxWrapper;
